import { useState, useEffect } from "react";
import { useData, useDispatch } from "./DataContext.js";

import Markdown from "react-markdown";
import RehypeRaw from "rehype-raw";
import RemarkGfm from "remark-gfm";

import Modal from "react-bootstrap/Modal";
import MarkdownComponents from "./MarkdownComponents.js";

export default function InformationModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();
    
    const [fileContent, setFileContent] = useState("__Chargement en cours...__");

    useEffect(() => {
	if (gData.state.currentInformationId === null) setFileContent("__Chargement en cours...__");
	else
	{
	    const informationContent = gData.content.documents[gData.state.currentInformationId];
	    fetch(gData.gameId + "/documents/" + informationContent.id + "." + informationContent.ext)
		.then((response) => { return response.text(); })
		.then((text) => { setFileContent(text); });
	}
    }, [gData.state.currentInformationId, gData.content, gData.gameId]);

    const informationId = gData.state.currentInformationId;
    if (informationId === null) return (<></>);

    const informationContent = gData.content.documents[informationId];

    function closeInformation () { gDispatch({ type: "closeInformation" }); }

    let content = (<></>);
    switch (informationContent.ext)
    {
	case "jpg" : content = (<img className="w-100" alt="Document" src={ gData.gameId + "/documents/" + informationContent.id + "." + informationContent.ext }/>); break;
	case "md" : content = (<Markdown components={MarkdownComponents} remarkPlugins={[RemarkGfm]} rehypePlugins={[ RehypeRaw ]}>{fileContent}</Markdown>); break;
	default :
    }
    
    return (
	<Modal
	    size="lg"
	    show={gData.state.showModals.information}
	    onHide={closeInformation}	    
	>
	    <Modal.Header className="bg-light" closeButton>
		<Modal.Title className="text-uppercase">
		    {informationContent.title}
		</Modal.Title>
	    </Modal.Header>
	    <Modal.Body className={informationContent.ext === "jpg" ? "p-0" : ""}>
		{content}
	    </Modal.Body>
	</Modal>
    );
}
